<!--
  --
  -- 送迎・配車サービス 場所入力コンポーネント
  --
  -->
<template>
  <div class="c-pick-place">
    <!-- 場所を表示するのみ -->
    <template v-if="inputType === 'static'">
      <div class="my-4 text-body-1">
        <span class="primary--text">{{label}}:&nbsp;</span>
        <span>{{text}}</span>
      </div>
    </template>

    <!-- 任意の場所入力 -->
    <template v-if="inputType === 'text'">
      <v-text-field
        v-model="text"
        :label="label"
        :disabled="disabled"
      />
    </template>

    <!-- 選択肢 -->
    <template v-if="inputType === 'select' || inputType === 'select-other'">
      <v-radio-group
        v-model="index"
        :label="label"
        :disabled="disabled"
      >
        <!-- places の一覧 -->
        <v-radio
          v-for="(p, index) in service.places"
          :key="index"
          :value="index"
          :label="p"
        />

        <!-- その他 -->
        <v-radio
          v-if="inputType === 'select-other'"
          :value="-1"
        >
          <template #label>
            <span>その他</span>

            <v-text-field
              v-model="text"
              :disabled="index !== -1"
              class="ml-4 mt-0"
              dense hide-details
            />
          </template>
        </v-radio>
      </v-radio-group>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CPickPlace',
  props: {
    label: {
      type: String,
      default: ''
    },
    service: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    // 選択肢のインデックス
    index: -1,

    // 入力テキスト
    text: ''
  }),

  computed: {
    /**
     * 場所の入力タイプ
     */
    inputType () {
      const numPlaces = this.service.places.length // 選択肢の数
      const any = this.service.any // 任意入力の可否

      if (numPlaces === 0 && any) {
        return 'text' // テキスト入力
      }
      if (numPlaces === 1 && !any) {
        return 'static' // 固定表示
      }
      if (numPlaces > 0 && !any) {
        return 'select' // 選択肢
      }
      if (numPlaces > 0 && any) {
        return 'select-other' // 選択肢 + その他
      }

      return 'none'
    },

    /**
     * 場所入力の disabled を判定
     * サービスを利用しないなら disabled
     */
    disabled () {
      return this.service.value === 0
    }
  },

  /**
   * index, text の内容に応じて service.place を更新する
   */
  watch: {
    index (value) {
      if (value >= 0) {
        this.service.place = this.service.places[value]
      } else {
        this.service.place = this.text
      }
    },
    text (value) {
      this.service.place = this.text
    }
  },

  created () {
    // inputType に応じて、index, text を初期化する
    switch (this.inputType) {
      case 'text':
        this.text = this.service.place
        break
      case 'static':
        this.text = this.service.places[0]
        break
      case 'select':
        this.index = this.service.places.findIndex(p => p === this.service.place)
        if (this.index < 0) {
          this.index = 0
        }
        break
      case 'select-other':
        this.index = this.service.places.findIndex(p => p === this.service.place)
        if (this.index < 0) {
          this.text = this.service.place
        }
        break
    }
  }
}
</script>
